var SLIDE_ANIMATIONS = {
    SCROLL: 'SCROLL',
    FADE: 'FADE',
    DECK: 'DECK',
};
export default SLIDE_ANIMATIONS;
//# sourceMappingURL=slideAnimations.js.map